module.exports = __webpack_public_path__ + "static/media/bicycles_open_graph.27ff823b.jpg";